(() => {
  'use strict';
  const cart = window.BasicCart;
  if (!cart) return;

  const byId = id => document.getElementById(id);
  const empty = byId('cart-empty');
  const content = byId('cart-content');
  const list = byId('cart-items');
  const subtotal = byId('cart-subtotal');
  const savingsRow = byId('cart-savings-row');
  const savingsAmount = byId('cart-savings');
  const shipping = byId('cart-shipping');
  const total = byId('cart-total');
  const unknownNote = byId('cart-unknown-note');
  const checkoutForm = byId('cart-checkout-form');
  const checkoutButton = byId('cart-checkout-button');
  const liveStatus = byId('cart-live-status');
  const count = byId('cart-item-count');
  if (!empty || !content || !list || !checkoutForm) return;
  const rewards = window.BasicCartRewards.create();
  byId('cart-rewards').append(rewards);

  function localPage(item) {
    return /^[a-z0-9-]+\.html$/.test(item.page || '') ? item.page : 'index.html';
  }

  function lineImage(item) {
    const link = document.createElement('a');
    link.className = 'cart-line-image';
    link.href = localPage(item);
    link.setAttribute('aria-label', `Revoir ${item.title}`);
    const image = document.createElement('img');
    image.src = cart.imageUrl(item.image);
    image.alt = '';
    image.loading = 'lazy';
    link.append(image);
    return link;
  }

  function changeQuantity(itemId, delta) {
    const items = cart.read();
    const item = items.find(entry => entry.id === itemId);
    if (!item) return;
    item.quantity = Math.max(1, Math.min(cart.MAX_QUANTITY, item.quantity + delta));
    cart.write(items);
    render();
    liveStatus.textContent = `Quantité mise à jour pour ${item.title}.`;
  }

  function remove(itemId) {
    const items = cart.read();
    const item = items.find(entry => entry.id === itemId);
    if (!item) return;
    cart.write(items.filter(entry => entry.id !== itemId));
    render();
    liveStatus.textContent = `${item.title} retiré du panier.`;
  }

  function quantityControl(item) {
    const wrapper = document.createElement('div');
    wrapper.className = 'cart-quantity';
    wrapper.setAttribute('role', 'group');
    wrapper.setAttribute('aria-label', `Nombre de sélections de ${item.title}`);
    const minus = document.createElement('button');
    minus.type = 'button';
    minus.textContent = '−';
    minus.setAttribute('aria-label', `Retirer une sélection de ${item.title}`);
    minus.disabled = item.quantity <= 1;
    minus.addEventListener('click', () => changeQuantity(item.id, -1));
    const output = document.createElement('output');
    output.textContent = String(item.quantity);
    const plus = document.createElement('button');
    plus.type = 'button';
    plus.textContent = '+';
    plus.setAttribute('aria-label', `Ajouter une sélection de ${item.title}`);
    plus.disabled = item.quantity >= cart.MAX_QUANTITY;
    plus.addEventListener('click', () => changeQuantity(item.id, 1));
    wrapper.append(minus, output, plus);
    return wrapper;
  }

  function renderLine(item) {
    const article = document.createElement('article');
    article.className = 'cart-line';
    const body = document.createElement('div');
    body.className = 'cart-line-body';
    const title = document.createElement('a');
    title.className = 'cart-line-title';
    title.href = localPage(item);
    title.textContent = item.title;
    const meta = document.createElement('p');
    meta.className = 'cart-line-meta';
    meta.textContent = item.detail || '';
    const actions = document.createElement('div');
    actions.className = 'cart-line-actions';
    const removeButton = document.createElement('button');
    removeButton.type = 'button';
    removeButton.className = 'cart-remove';
    removeButton.textContent = 'Retirer';
    removeButton.setAttribute('aria-label', `Retirer ${item.title} du panier`);
    removeButton.addEventListener('click', () => remove(item.id));
    actions.append(quantityControl(item), removeButton);
    body.append(title, meta, actions);
    const pricing = document.createElement('div');
    pricing.className = 'cart-line-pricing';
    const price = document.createElement('strong');
    price.className = 'cart-line-price';
    price.textContent = item.price === null ? 'À confirmer' : cart.money(item.price * item.quantity);
    pricing.append(price);
    const savings = cart.savingsFor(item);
    if (savings > 0) {
      const saving = document.createElement('span');
      saving.className = 'cart-line-savings';
      saving.textContent = `${cart.money(savings)} économisés`;
      pricing.append(saving);
    }
    article.append(lineImage(item), body, pricing);
    return article;
  }

  function render() {
    const items = cart.read();
    const hasItems = items.length > 0;
    empty.hidden = hasItems;
    content.hidden = !hasItems;
    checkoutButton.disabled = !hasItems;
    if (!hasItems) {
      list.replaceChildren();
      count.textContent = '0 produit';
      return;
    }

    const summary = cart.totals(items);
    list.replaceChildren(...items.map(renderLine), ...(summary.giftUnlocked ? [window.BasicCartRewards.giftLine()] : []));
    const {known,savings,missingPrice,uncertain,delivery,selectionCount} = summary;
    count.textContent = `${selectionCount} ${selectionCount === 1 ? 'sélection' : 'sélections'}`;
    subtotal.textContent = missingPrice ? `${cart.money(known)} + à confirmer` : cart.money(known);
    savingsRow.hidden = savings <= 0;
    savingsAmount.textContent = cart.money(savings);
    shipping.textContent = uncertain ? 'À confirmer' : delivery === 0 ? 'Offerte' : cart.money(delivery);
    total.textContent = uncertain ? 'À confirmer' : cart.money(known + delivery);
    window.BasicCartRewards.render(rewards, summary);
    if (unknownNote) unknownNote.hidden = !uncertain;
  }

  checkoutForm.addEventListener('submit', event => {
    if (!cart.read().length) event.preventDefault();
  });

  window.addEventListener('basic-cart-change', render);
  window.addEventListener('storage', render);
  render();
})();
